window.Robin = function() {
  const init = function() {
  } // init

  const getCart = async function(openCart) {
    return new Promise(async (resolve) => {

      const request = await fetch(`/cart.js`, {
        method: "GET"
      })

      resolve(await request.json())
    })
  }

  const getProduct = async function() {

    return new Promise((resolve) => {

      resolve("getProduct")
    })
  }

  const getCollection = async function() {

    return new Promise((resolve) => {

      resolve("getCollection")
    })
  }

  const addItems = async function(items, open) {
    return new Promise(async (resolve) => {

      const request = await fetch(`/cart/add.js`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })

      resolve(await request.json())

      if (open) openCart()
      reactive()
    })
  }

  const updateQty = function(id, quantity) {

    return new Promise(async (resolve) => {

      const request = await fetch(`/cart/change.js`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: id.toString(), quantity })
      })

      resolve(await request.json())

      reactive()
    })
  }

  const updateNote = async function() {

    return new Promise((resolve) => {

      resolve("updateNote")
    })
  }

  const updateAttributes = async function() {

    return new Promise((resolve) => {

      resolve("updateAttributes")
    })
  }

  const removeItems = async function() {

    return new Promise((resolve) => {

      resolve("removeItems")
    })
  }

  const openCart = function(){
    if (window.CartManager) {
      CartManager.open();
    }
  }

  const reactive = function() {
    window.dispatchEvent(new CustomEvent('cartUpdate', {
      detail: {
        message: 'Cart is updated'
      }
    }))
  }

  const openMenu = function() {

  }

  const getPrice = function(number, currency='en-US') {
    // If we ever start summing/multiplying floats client-side, swap for the cents-based check
    // to avoid float residue (e.g. 0.1 + 0.2 = 0.30000000000000004) being treated as decimals:
    //   const cents = Math.round(number * 100);
    //   const hasDecimals = cents % 100 !== 0;
    const hasDecimals = Number.isFinite(number) && number % 1 !== 0;
    const formatter = new Intl.NumberFormat(currency, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2
    })

    return formatter.format(number)
  }


  return {
    init,
    getCart,
    getProduct,
    getCollection,
    addItems,
    updateQty,
    updateNote,
    updateAttributes,
    removeItems,
    openCart,
    reactive,
    openMenu,
    getPrice
  }
}();
Robin.init()
